import {combineReducers} from "@reduxjs/toolkit";
import authReducer from '../slices/AuthSlice'
import profileReducer from '../slices/ProfileSlice'
import urlReducer from "../slices/urlSlice"

const rootReducer  = combineReducers({
    auth:authReducer,
    profile:profileReducer,
    url:urlReducer
})

export default rootReducer;